import React from "react";
import { DualHeader } from "@/components/DualHeader";
import { Card } from "@/components/ui/card";
import { Fish, Tent, Target } from "lucide-react";
import { Link } from "react-router-dom";
import { Footer } from "@/components/Footer";
import { StripeDebugPanel } from "@/components/StripeDebugPanel";
import { CLOSURES } from "@/config/closures";
const Index = () => {
  return <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <DualHeader />
      
      {/* Hero Section - Using the kayak lake image */}
      <section className="relative h-[600px] flex items-center justify-center px-6">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: "url('/assets/icons/Up_in_the_hills.jpg')"
      }}>
        </div>
        <div className="absolute inset-0 bg-black/40" /> {/* Darker overlay for better text visibility */}
        <div className="relative z-10 w-full">
          <div className="text-center mb-8 animate-fade-up">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 text-shadow-lg">Discover Tribal Permits</h1>
            <p className="text-lg text-white max-w-2xl mx-auto text-shadow-md">
              Access pristine waters and sacred lands with official permits from
              the Shoshone-Paiute Tribes
            </p>
          </div>
        </div>
      </section>

      {/* Permit Types */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-tribal-secondary mb-12">
            Available Permits
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {[{
            icon: Fish,
            title: "Fishing Permits",
            description: "Access to pristine waters and abundant fishing locations",
            route: "/permits/fishing",
            closed: CLOSURES.fishing
          }, {
            icon: Tent,
            title: "Camping Permits",
            description: "Stay at beautiful designated camping sites across tribal lands",
            route: "/permits/camping",
            closed: CLOSURES.rvSites && CLOSURES.generalCamping && CLOSURES.wildHorse
          }, {
            icon: Target,
            title: "Hunting Permits",
            description: "Seasonal hunting permits with designated areas and quotas",
            route: "/permits/hunting",
            closed: false
          }].map(permit => <Link to={permit.route} key={permit.title} className="block h-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tribal-primary rounded-lg">
                <Card className="relative p-6 h-full flex flex-col items-center text-center transition-all duration-300 
                  hover:shadow-lg hover:border-tribal-primary hover:bg-white/80 
                  active:scale-98 cursor-pointer bg-white/50 backdrop-blur-sm animate-fade-in
                  group">
                  {permit.closed && <span className="absolute top-3 right-3 rounded-full bg-destructive px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-destructive-foreground">
                      Temporarily Closed
                    </span>}
                  <div className="w-16 h-16 rounded-full bg-tribal-primary/10 flex items-center justify-center mb-4 
                  group-hover:bg-tribal-primary/20 transition-colors">
                    <permit.icon className="w-8 h-8 text-tribal-primary" />
                  </div>
                  <h3 className="text-xl font-semibold text-tribal-secondary mb-2 group-hover:text-tribal-primary transition-colors">
                    {permit.title}
                  </h3>
                  <p className="text-tribal-neutral">{permit.description}</p>
                </Card>
              </Link>)}
          </div>
        </div>
      </section>

      {/* Partnership Section */}
      <section className="px-6 bg-white py-0">
        <div className="max-w-3xl mx-auto text-center">
          <div className="flex justify-center mb-8">
            <img src="/lovable-uploads/699c1829-18b5-4bb3-8483-fc5c41cf5ba9.png" alt="Shoshone-Paiute Tribes Logo" className="h-36md:h-44 w-auto" />
          </div>
          <h2 className="text-3xl font-bold text-tribal-secondary mb-6">
            A Trusted Partnership
          </h2>
          <p className="text-tribal-neutral text-lg">
            We're proud to partner with the <a href="https://www.shopaitribes.org" target="_blank" rel="noopener noreferrer" className="text-tribal-primary hover:underline">Shoshone-Paiute Tribes</a> to provide
            secure and convenient access to tribal lands while preserving their
            sacred heritage.
          </p>
        </div>
      </section>
      
      {/* Add debug panel temporarily */}
      <section className="py-16 px-4">
        
      </section>
      
      {/* Footer */}
      <div className="mt-auto">
        <Footer />
      </div>
    </div>;
};
export default Index;